import { createZoomInBanner } from "@js/utils/zoomInBanner";

document.addEventListener("DOMContentLoaded", () => {
  const zoomInBanner = document.querySelectorAll(".zoom-in-banner");
  zoomInBanner.forEach((item) => {
    const section = item;
    createZoomInBanner(section);
  });
});
